import React, { useContext } from 'react';
import { Link } from 'react-router-dom';

import { AppContext } from '../context';
import starFull from '../../images/star.png';
import starO from '../../images/star-o.png';

const Ratings = () => {
  const { aggregateRating } = useContext(AppContext);
  let averageRating, totalReviews, widthCount;
  if (aggregateRating) {
    averageRating = aggregateRating.count;
    totalReviews = aggregateRating.ratings;
    widthCount = averageRating * 35.4
  }

  if (averageRating !== null && averageRating !== undefined) {
    return (
      <div className="Footer-Overview__Ratings">
        <div className="Footer-Overview__Ratings--Starts">
          <div style={{ backgroundImage: `url(${starO})` }}>
            <span 
              style={{ 
                backgroundImage: `url(${starFull})`,
                width: `${widthCount}px`
              }}
            ></span>
          </div>
        </div>
        <Link to="/customers-review" className="Footer-Overview__Ratings--TotalReview">Based on {totalReviews} reviews</Link>
        <h3 className="Footer-Overview__Ratings--Count">{averageRating} / 5</h3>
      </div>
    );
  }

  return null;
};

export default Ratings;